/**
 * @generated SignedSource<<7f8a8b2bfa4f9aef01c036aed6c33753>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteManualOrderInput = {
  clientMutationId?: string | null;
  id: string;
};
export type manualOrdersTable_DeleteManualOrderMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteManualOrderInput;
};
export type manualOrdersTable_DeleteManualOrderMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly DeleteManualOrder: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null;
    };
  };
};
export type manualOrdersTable_DeleteManualOrderMutation = {
  response: manualOrdersTable_DeleteManualOrderMutation$data;
  variables: manualOrdersTable_DeleteManualOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "manualOrdersTable_DeleteManualOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteManualOrderPayload",
                "kind": "LinkedField",
                "name": "DeleteManualOrder",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "manualOrdersTable_DeleteManualOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteManualOrderPayload",
                "kind": "LinkedField",
                "name": "DeleteManualOrder",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c363ad969db29a1cb32258b076737ef4",
    "id": null,
    "metadata": {},
    "name": "manualOrdersTable_DeleteManualOrderMutation",
    "operationKind": "mutation",
    "text": "mutation manualOrdersTable_DeleteManualOrderMutation(\n  $input: DeleteManualOrderInput!\n) {\n  Admin {\n    Billing {\n      DeleteManualOrder(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bcdcfde61c95b5cec3c13eaa669aa53a";

export default node;
